import EventBus from './event-bus';
import axios from "axios";

const EVENT = 'apiConnectionError';

export default class API {
    baseUrl;

    constructor() {
        this.setBaseUrl(process.env.VUE_APP_ACCOUNT_MANAGER_API);
        this.setAxiosInterceptors();
    }

    setBaseUrl(url) {
        const root = (process.env.VUE_APP_ROOT_DOMAIN || window.location.hostname)
            .split('.')
            .slice(-2)
            .join('.');
        url = url.replace('ROOT_DOMAIN', root);
        url = url.slice(-1) === '/'
            ? url.slice(0, -1)
            : url;
        this.baseUrl = url;
    }

    setAxiosInterceptors() {
        axios.interceptors.response.use(
            (response) => response,
            error => {
                if (!error.response) {
                    EventBus.$emit(EVENT, true);
                }
                return Promise.reject(error);
            });
    }

    url(url) {
        return this.baseUrl
            + (url.slice(0, 1) === '/' ? '' : '/')
            + url;
    }

    request(config) {
        return axios.request(config);
    }

    get(url, config) {
        return axios.get(this.url(url), config);
    }

    delete(url, config) {
        return axios.delete(this.url(url), config);
    }

    head(url, config) {
        return axios.head(this.url(url), config);
    }

    options(url, config) {
        return axios.options(this.url(url), config);
    }

    post(url, data, config) {
        return axios.post(this.url(url), data, config);
    }

    put(url, data, config) {
        return axios.put(this.url(url), data, config);
    }

    patch(url, data, config) {
        return axios.patch(this.url(url), data, config);
    }
}